export default {
  siteName: '番号本',
  siteSlogan: '专业番号查询与收录平台',
  navHome: '首页',
  navCategories: '分类浏览',
  navAbout: '关于我们',
  navSearch: '搜索番号...',
  btnSearch: '搜索',
  btnViewAll: '查看全部',
  btnReadMore: '阅读全文',
  btnSubmit: '提交',
  footerCopyright: '© 2026 番号本. 保留所有权利.',
  footerAbout: '关于番号本',
  footerTerms: '使用条款',
  footerPrivacy: '隐私政策',
  footerContact: '联系我们',
};